module.exports = __webpack_public_path__ + "img/frame (221).15ca7a0f.jpg";